import React from 'react';
import {SearchMenu} from './SearchMenu';
import {Grid} from 'react-bootstrap';
import {Col} from 'react-bootstrap';
import FontAwesome from "react-fontawesome";
import {AdministrationUtilities} from "../administration/AdministrationHelper";

import stylesSearchPage from '../_css/dictionary/searchPage.module.css';
import stylesLexemePage from '../_css/dictionary/lexemePage.module.css';
import BUtils from './../utilities/BaseUtilities';
import {DictionarySettings, Notifications} from "../utilities/DictUtilities";
import {LexemeUtilities} from "../lexeme/page/editor/LexemeHelper";
import {getRootEntryId} from "../lexeme/page/LexemePage";
import Dict from "dict-lib";
import {SCTrash} from "../dict-components/trash/SCTrash";

export class SearchPage extends React.Component {
    constructor(props) {
        super(props);
    }



    render() {

        var matchModule = AdministrationUtilities.getModuleByPathName(this.props.match.path);
        const topic = this.props.match.params.topic;
        const isIframe = BUtils.isInIframe();

        return <Grid fluid id="dict-search" className={BUtils.joinClasses(stylesSearchPage['dict-search'], isIframe ? 'dict-search--iframe' : '')}>
            <SearchMenu ref="ref-search-menu" module={matchModule} topic={topic}/>
            <div id="dict-result-content" className={BUtils.joinClasses(stylesSearchPage['dict-result-content'], stylesSearchPage['dict-result-content--' + matchModule.code])}>
                <div id="dict-result-container-buttonbar"
                     className={stylesSearchPage['dict-result-container-buttonbar']}/>
                <Col lg={3} md={3} id="dict-result-container" className={BUtils.joinClasses(stylesSearchPage['dict-result-container'])}
                     style={{backgroundColor: 'white', backgroundClip: 'contentBox'}}/>
                <Col lg={8} md={8} id="lexeme-page-container"
                     className={BUtils.joinClasses(stylesSearchPage['lexeme-page-container'], stylesSearchPage['lexeme-page-container-right'])}/>
                <div id={'export-container'} style={{display: 'none'}}/>
                <SCTrash/>
            </div>
        </Grid>
    }
}

